import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    apiUrl: "https://api.traceytrustschool.co.za",
    saveFormDataRoute: "/auth/save-form-data",
    updateFormDataRoute: "/auth/update-item",
    updateModelSingleRowRoute: "/auth/update-model-single-row",
    deleteSingleRowRoute: "/auth/delete-single-row",
    deleteMultipleRowsRoute: "/auth/delete-multiple-rows",

    allSMSGroupsRoute: "/auth/get-all-sms-groups", //not taken to others yet
    selectedGroupMembersRoute: "/auth/get-selected-group-members",
    updateItemRoute: "/auth/update-model-single-row",
    saveGroupMemberRoute: "/auth/save-group-member",
    sendSMSCGPTRoute: "/auth/send-sms-cgpt",
    smsCreditsRoute: "/auth/get-sms-credits",
    allPredefinedSMSesRoute: "/auth/get-all-predefined-smses",
    smsAnalyticsRoute: "/auth/get-data-and-analytics",
    createGroupOrUpdateGroupRoute: "/auth/create-or-update-group",
    addMembersToGroupsRoute: "/auth/add-members-to-groups",
    smsLogForInstitutionRoute: "/auth/get-sms-log-for-institution",
    resendSMSRoute: "/auth/resend-bulk-sms",

    //Email Routes
    sendStatementsViaEmailRoute: "/auth/send-statements-via-email",

    socket: {},
    endPoint: "wss://express.bitsems.co.za",
    frontPageImages: [],
    bitsems: false,
    takePhotos: ["adubyte2@yahoo.com", "concordf14@gmail.com"],
    articles: [],
    postBody: "Type here ...",
    siteStats: {},
    pdfHTML: "Generating PDF",
    pdfFilename: "pdf",
    accessToken: localStorage.getItem("token") || "",
    authenticated: false,
    themeColor: localStorage.getItem("themeColor") || "white",
    secondaryColor: localStorage.getItem("secondaryColor") || "white",
    Loader: false,
    appName: localStorage.getItem("appName") || "",
    components: [],
    userSchool: JSON.parse(localStorage.getItem("userSchool")) || {},
    userStudents: [],
    userSelectedStudentSid: null,
    currency: "R",
    currentSubject: {
      name: "",
      code: "",
      topic: {},
    },
    user: { alevel: 1 },
    currentStudent: null,
    allStudents: [],
    enableEditing: false,
    currentStudentProfile: null,
    marksScheduleParams: {},
    paymentInfo: {},
    expensesCategories: [],
    serviceProviders: [],
    selectedClass: null,
    globalDialogSlot: false,
    globalConfirmDelete: false,
    bulkSMSTokenId: "96C2A187620B41FAB3B31E0804F5EA06-01-2",
    bulkSMSTokenSecret: "mCQEABCuSZvZ106I9AKQR4hDAQjOQ",
    bulkSMSBasicAuth:
      "Authorization: Basic OTZDMkExODc2MjBCNDFGQUIzQjMxRTA4MDRGNUVBMDYtMDEtMjptQ1FFQUJDdVNadloxMDZJOUFLUVI0aERBUWpPUQ==",
    pdf: null,
    vuetify: JSON.parse(localStorage.getItem("vuetify")) || null,
    isMobile: false,
    confirmDelete: false,
    logoPath: null,
    bitsems: false,
  },
  getters: {
    isMobile(state) {
      return state.isMobile;
    },
    getSaveFormDataRoute(state) {
      return state.saveFormDataRoute;
    },
    getUpdateFormDataRoute(state) {
      return state.updateFormDataRoute;
    },
    getUpdateModelSingleRowRoute(state) {
      return state.updateModelSingleRowRoute;
    },
    getDeleteSingleRowRoute(state) {
      return state.deleteSingleRowRoute;
    },
    getDeleteMultipleRowsRoute(state) {
      return state.deleteMultipleRowsRoute;
    },
    getAllSMSGroupsRoute(state) {
      return state.allSMSGroupsRoute;
    },
    getSelectedGroupMembersRoute(state) {
      return state.selectedGroupMembersRoute;
    },
    getUpdateItemRoute(state) {
      return state.updateItemRoute;
    },
    getSaveGroupMemberRoute(state) {
      return state.saveGroupMemberRoute;
    },
    getSendSMSCGPTRoute(state) {
      return state.sendSMSCGPTRoute;
    },
    getSMSCreditsRoute(state) {
      return state.smsCreditsRoute;
    },
    getAllPredefinedSMSesRoute(state) {
      return state.allPredefinedSMSesRoute;
    },
    getSMSAnalyticsRoute(state) {
      return state.smsAnalyticsRoute;
    },
    getCreateGroupOrUpdateGroupRoute(state) {
      return state.createGroupOrUpdateGroupRoute;
    },
    getAddMembersToGroups(state) {
      return state.addMembersToGroupsRoute;
    },
    getSMSLogForInstitutionRoute(state) {
      return state.smsLogForInstitutionRoute;
    },
    getResendSMSRoute(state) {
      return state.resendSMSRoute;
    },

    //Email Route Getters
    getSendStatementsViaEmailRoute(state) {
      return state.sendStatementsViaEmailRoute;
    },
    getLogoPath(state) {
      if (localStorage.getItem("logoPath")) {
        state.logoPath = localStorage.getItem("logoPath");
      }
      return state.logoPath;
    },
    getConfirmDelete(state) {
      return state.confirmDelete;
    },
    getClass(state) {
      return state.vuetify.breakpoint.smAndDown
        ? "ml-4 mt-1 mr-4"
        : "mt-1 mx-2";
    },
    getAllStudents(state) {
      return state.allStudents;
    },
    getGlobalDialogSlot(state) {
      return state.globalDialogSlot;
    },
    getGlobalConfirmDelete(state) {
      return state.globalConfirmDelete;
    },
    getSelectedClass(state) {
      return state.selectedClass;
    },
    getExpensesCategories(state) {
      return state.expensesCategories;
    },
    getServiceProviders(state) {
      return state.serviceProviders;
    },
    getBulkSMSTokenId(state) {
      return state.bulkSMSTokenId;
    },
    getBulkSMSTokenSecret(state) {
      return state.bulkSMSTokenSecret;
    },
    getBulkSMSBasicAuth(state) {
      return state.bulkSMSBasicAuth;
    },
    getSocket(state) {
      return state.socket;
    },
    getEndPoint(state) {
      return state.endPoint;
    },
    getTakePhotos(state) {
      return state.takePhotos;
    },
    getFrontPageImages(state) {
      return state.frontPageImages;
    },
    itsBitsems(state) {
      if (localStorage.getItem("bitsems")) {
        state.bitsems = localStorage.getItem("bitsems");
      }
      return state.bitsems;
    },
    isManager(state) {
      return state.user.alevel >= 9;
    },
    isAdmin(state) {
      return state.user.alevel >= 7;
    },
    isStaff(state) {
      return state.user.alevel >= 5;
    },
    isParentOrStudent(state) {
      return state.user.alevel == 3;
    },
    isGuest(state) {
      return state.user.alevel == 1;
    },
    isEverybody() {
      return true;
    },
    isEverybodyEA(state) {
      return state.user.alevel < 6;
    },
    getApiUrl(state) {
      return state.apiUrl;
    },
    getArticles(state) {
      return state.articles;
    },
    getSiteStats(state) {
      return state.siteStats;
    },
    enableEditing(state) {
      return state.enableEditing;
    },
    getPdfHTML(state) {
      return state.pdfHTML;
    },
    getPdfFilename(state) {
      return state.pdfFilename;
    },
    getAuthenticated(state) {
      if (localStorage.getItem("authenticated") != null) {
        state.authenticated = true;
      }
      return state.authenticated;
    },
    getComponents(state) {
      return state.components;
    },
    getCurrency(state) {
      return state.currency;
    },
    getUserStudents(state) {
      return state.userStudents;
    },
    getUserSelectedStudentSid(state) {
      return state.userSelectedStudentSid;
    },
    getAppName(state) {
      if (localStorage.getItem("appName") != null) {
        state.appName = localStorage.getItem("appName");
      }
      return state.appName;
    },
    getUserSchool(state) {
      if (JSON.parse(localStorage.getItem("userSchool"))) {
        state.userSchool = JSON.parse(localStorage.getItem("userSchool"));
      }
      return state.userSchool;
    },
    getCurrentUser(state) {
      if (JSON.parse(localStorage.getItem("user")) != null) {
        state.user = JSON.parse(localStorage.getItem("user"));
      }
      return state.user;
    },
    getCurrentStudentProfile(state) {
      return state.currentStudentProfile;
    },
    getThemeColor(state) {
      if (localStorage.getItem("themeColor")) {
        state.themeColor = localStorage.getItem("themeColor");
      }
      return state.themeColor;
    },
    getSecondaryColor(state) {
      if (localStorage.getItem("secondaryColor")) {
        state.secondaryColor = localStorage.getItem("secondaryColor");
      }
      return state.secondaryColor;
    },
    getThemeStyle(state) {
      return {
        "background-color": state.themeColor,
        color: state.secondaryColor,
      };
    },
    getInvertedStyle(state) {
      return {
        "background-color": state.secondaryColor,
        color: state.themeColor,
      };
    },
    getOutlineColor(state) {
      return state.secondaryColor == "#FFFFFF" ||
        state.secondaryColor == "#ffffff" ||
        state.secondaryColor == "white"
        ? state.themeColor
        : state.secondaryColor;
    },
    getLoader(state) {
      return state.Loader;
    },
    getCurrentSubject(state) {
      return state.currentSubject;
    },
    getAccessToken(state) {
      if (localStorage.getItem("token") != null) {
        state.accessToken = localStorage.getItem("token");
      }
      return state.accessToken;
    },
    getCurrentStudent(state) {
      return state.currentStudent;
    },
    getPaymentInfo(state) {
      return state.paymentInfo;
    },
    getPostBody(state) {
      return state.postBody;
    },
    getMarksScheduleParams(state) {
      return state.marksScheduleParams;
    },
    getPDF(state) {
      return state.pdf;
    },
  },
  mutations: {
    setItsBitsems(state, payload) {
      state.bitsems = payload;
      localStorage.setItem("bitsems", payload);
    },
    setIsMobile(state, payload) {
      state.isMobile = payload;
    },
    setLogoPath(state, payload) {
      state.logoPath = payload;
      localStorage.setItem("logoPath", payload);
    },
    setConfirmDelete(state, payload) {
      state.confirmDelete = payload;
    },
    setVuetifyObject(state, payload) {
      state.vuetify = payload;
    },
    setAllStudents(state, payload) {
      state.allStudents = payload;
    },
    setGlobalDialogSlot(state, payload) {
      state.globalDialogSlot = payload;
    },
    setGlobalConfirmDelete(state, payload) {
      state.globalConfirmDelete = payload;
    },
    setSelectedClass(state, payload) {
      state.selectedClass = payload;
    },
    setSocket(state, socket) {
      state.socket = socket;
    },
    setBitsems(state, boolVal) {
      state.bitsems = boolVal;
    },
    setFrontPageImages(state, frontPageImages) {
      state.frontPageImages = frontPageImages;
    },
    setSiteArticles(state, articles) {
      state.articles = articles;
    },
    setSiteStats(state, stats) {
      state.siteStats = stats;
    },
    enableEditing(state, payload) {
      state.enableEditing = payload;
    },
    setPdfHTML(state, html) {
      state.pdfHTML = html;
    },
    setPdfFilename(state, filename) {
      state.pdfFilename = filename;
    },
    setThemeColor(state, color) {
      state.themeColor = color;
    },
    setSecondaryColor(state, color) {
      state.secondaryColor = color;
    },
    setAppName(state, appName) {
      state.appName = appName;
    },
    setUserSchool(state, school) {
      state.userSchool = school;
      localStorage.setItem("userSchool", JSON.stringify(school));
    },
    setAuthenticated(state, payload) {
      state.authenticated = payload;
    },
    setCurrentSubject(state, payload) {
      state.currentSubject = payload;
    },
    setAccessToken(state, payload) {
      state.accessToken = payload;
    },
    setCurrentUser(state, payload) {
      state.user = payload;
    },
    setUserStudents(state, payload) {
      state.userStudents = payload;
    },

    setCurrentStudent(state, student) {
      state.currentStudent = student;
    },
    setCurrentStudentProfile(state, studentProfile) {
      state.currentStudentProfile = studentProfile;
    },

    setLoader(state, payload) {
      state.Loader = payload;
    },
    pushToComponents(state, payload) {
      state.components = payload;
    },
    initializeComponents(state, payload) {
      state.components = payload;
    },
    setPaymentInfo(state, paymentInfo) {
      state.paymentInfo = paymentInfo;
    },
    setMarksScheduleParams(state, params) {
      state.marksScheduleParams = params;
    },
    setExpensesCategories(state, categories) {
      state.expensesCategories = categories;
    },
    setServiceProviders(state, serviceProviders) {
      state.serviceProviders = serviceProviders;
    },
    sliceComponent(state, index) {
      state.components = state.components.filter((element, i) => {
        return i != index;
      });
    },
    updateStoreComponent(state, { index, componentSection, imgData }) {
      let obj = { content: null, arrayIndex: null, imgData: null };
      obj = state.components[index];
      obj.content = componentSection;
      obj.arrayIndex = index;
      obj.imgData = imgData;
    },
    setPostBody(state, postBody) {
      state.postBody = postBody;
    },
    setPDF(state, dataUrl) {
      state.pdf = dataUrl;
    },
  },
  actions: {
    setCurrentUser(context, token) {
      axios
        .get("/auth/user", { headers: { Authorization: "Bearer " + token } })
        .then((response) => {
          return response.data;
        })
        .then((user) => {
          context.commit("setCurrentUser", user);
        });
    },
    setUserStudents(context, { userId, token }) {
      const studentsArr = [];
      axios
        .post(
          "/auth/get-user-students",
          { userId: userId },
          { headers: { Authorization: "Bearer " + token } }
        )
        .then((response) => {
          return response.data;
        })
        .then((students) => {
          students.forEach((student) => {
            studentsArr.push({
              text:
                student.fname + " " + student.lname + "[" + student.sid + "]",
              value: student.sid,
            });
          });

          context.commit("setUserStudents", studentsArr);
        });
    },
  },
  modules: {},
});
